import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './FooterSimple.css';

const FooterSimple = () => {
  const navigate = useNavigate();

  const handleContactUsClick = () => {
    navigate('/#HomePage-contact-faq-section');
    setTimeout(() => {
      const contactSection = document.getElementById('HomePage-contact-faq-section');
      if (contactSection) {
        const header = document.querySelector('.menu-bar');
        const headerHeight = header ? header.offsetHeight : 60;
        const elementTop = contactSection.offsetTop;
        const offsetPosition = elementTop - headerHeight - 20;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }, 500);
  };

  return (
    <footer className="footer-simple">
      <span className="footer-simple-copyright">
        &copy; {new Date().getFullYear()} My Speed Vault. All rights reserved.
      </span>
      <div className="footer-simple-links">
        <Link to="/blog" className="footer-simple-link">Blog</Link>
        <span className="footer-simple-separator">&nbsp;&bull;&nbsp;</span>
        <button type="button" className="footer-simple-link footer-simple-button" onClick={handleContactUsClick}>Contact Us</button>
        <span className="footer-simple-separator">&nbsp;&bull;&nbsp;</span>
        <Link to="/privacypolicy" className="footer-simple-link">Privacy Policy</Link>
      </div>
    </footer>
  );
};

export default FooterSimple;
